import { render, staticRenderFns } from "./IcExpansion.vue?vue&type=template&id=0b744d36&scoped=true"
import script from "./IcExpansion.vue?vue&type=script&lang=js"
export * from "./IcExpansion.vue?vue&type=script&lang=js"
import style0 from "./IcExpansion.vue?vue&type=style&index=0&id=0b744d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b744d36",
  null
  
)

export default component.exports